module.exports = {
  annotate: require(281).annotate,
  Module: require(284),
  Injector: require(283)
};
